import stockService from 'common/services/stockService'
import utils from 'utils'

import invoiceModule from '../module'
import {
    checkWithDiskInfo,
    scratchCheck,
} from '../invoiceValidate'
import Ukey from '../model/Ukey'
import {
    reject
} from 'q'
import {
    rejects
} from 'assert'

function infoDetailFromDiskPrivate(invoice) {
    const deferred = this.$q.defer()
    switch (invoice.invType) {
    case '12':
        window.top.TaxCore.tax.VehicleInvInfoDetail(invoice, (data) => {
            deferred.resolve(data)
        }, invoice.saleCreditCode, invoice.ukeyCode, 0)
        break
    default:
        window.top.TaxCore.tax.QryInvInfoDetail(invoice, (data) => {
            deferred.resolve(data)
        }, invoice.saleCreditCode, invoice.ukeyCode, 0)
    }
    return deferred.promise
}

function writeBackToInvPrivate(invType, result) {
    const deferred = this.$q.defer()
    const service = this
    switch (invType) {
    case '12':
        service.httpRequest.post_writeBackToVehicleInv(result).then((res) => {
            deferred.resolve(res)
        }, () => {
            deferred.reject({
                retmsg: '发票已开具成功, 更新发票状态失败, 请稍后再试',
            })
        })
        break
    case '51':
        service.httpRequest.post_writeBackToElectronInv(result).then((res) => {
            deferred.resolve(res)
        }, () => {
            deferred.reject({
                retmsg: '发票已开具成功, 更新发票状态失败, 请稍后再试',
            })
        })
        break
    default:
        service.httpRequest.post_writeBackToInv(result).then((res) => {
            deferred.resolve(res)
        }, () => {
            deferred.reject({
                retmsg: '发票已开具成功, 更新发票状态失败, 请稍后再试',
            })
        })
    }
    return deferred.promise
}

function qryOvatInvWaitByIssuePrivate(invoice) {
    const deferred = this.$q.defer()
    const service = this
    switch (invoice.invType) {
    case '12':
        service.httpRequest.get_queryOvatInvoiceWaitVehicleByIssue({
            waitId: invoice.waitId,
        }).then((res) => {
            deferred.resolve(res)
        })
        break
    default:
        service.httpRequest.get_queryOvatInvoiceWaitByIssue({
            waitId: invoice.waitId,
            hardwareNo: invoice.hardwareNo,
        }).then((res) => {
            deferred.resolve(res)
        }, (err) => {
            deferred.reject(err)
        })
    }
    return deferred.promise
}
/**
 * 1.获取发票全部信息，列表只返回部分发票信息
 * 2.调控制台开票
 * 3.查控制台是否开成功
 * 4.成功回写e税云
 *
 * 失败仅回写开票即inv接口的错误
 */
function openWhenUnlockedPrivate(invoice) {
    const service = this
    const deferred = this.$q.defer()
    const qryOvatInvWaitByIssue = qryOvatInvWaitByIssuePrivate.bind(this)
    const infoDetailFromDisk = infoDetailFromDiskPrivate.bind(this)
    const writeBackToInv = writeBackToInvPrivate.bind(this)
    // 1.获取发票全部信息，列表只返回部分发票信息
    qryOvatInvWaitByIssue(invoice).then((res2) => {
        const realInvoice = res2.data.value
        // 机动车获取票面详情接口不一致 invoiceType取infoKind字段
        realInvoice.invoiceType = realInvoice.invoiceType || realInvoice.infoKind
        // 2.调控制台开票
        window.top.TaxCore.tax.inv(realInvoice.invoiceType, realInvoice, (data1) => {
            const SIDParam1 = $.parseJSON(data1.value)
            if (SIDParam1.retcode === '4011') { // 成功
                invoice.invoiceCode = SIDParam1.InfoTypeCode
                invoice.invoiceNumber = SIDParam1.InfoNumber
                // 3.查控制台是否开成功
                infoDetailFromDisk(invoice).then((data2) => {
                    const SIDParam2 = data2.retcode ? data2 : $.parseJSON(data2.value)
                    if (SIDParam2.retcode === '0') {
                        SIDParam2.xsdjbh = invoice.kplsh;
                        SIDParam2.waitId = invoice.waitId;
                        const result = JSON.stringify(SIDParam2)
                        // 4.成功回写e税云
                        writeBackToInv(invoice.invType, result).then((res) => {
                            invoice.invoiceId = res.data.value.invoiceId
                            invoice.invoiceCode = SIDParam2.fpdm || (SIDParam2.ARRAY && SIDParam2.ARRAY[0].TypeCode) || invoice.invoiceCode
                            invoice.invoiceNumber = SIDParam2.fphm || (SIDParam2.ARRAY && SIDParam2.ARRAY[0].InvNo) || invoice.invoiceNumber
                            deferred.resolve(SIDParam2)
                        })
                    } else {
                        service.httpRequest.post_writeOvatInvoiceFailReason({
                            reason: '开票成功但入库失败，请重新点击开票进行修复',
                            waitId: invoice.waitId,
                        }).finally(() => {
                            deferred.reject(SIDParam2)
                        })
                    }
                })
            } else { // 失败
                service.httpRequest.post_writeOvatInvoiceFailReason({
                    reason: SIDParam1.retmsg,
                    waitId: invoice.waitId,
                }).finally(() => {
                    deferred.reject(SIDParam1)
                })
            }
        }, invoice.saleCreditCode, invoice.ukeyCode, 0)
    }, (err) => {
        deferred.reject(err)
    })
    return deferred.promise
}

/**
 * 当发票锁定时开票流程
 * 1. 根据waitId查询是否开过
 * 2. 已经开成功回写e税云
 * 3. 未开成功直接开票
 */
function openWhenLockedPrivate(invoice) {
    const service = this
    const openWhenUnlocked = openWhenUnlockedPrivate.bind(this)
    const infoDetailFromDisk = infoDetailFromDiskPrivate.bind(this)
    const writeBackToInv = writeBackToInvPrivate.bind(this)
    const deferred = service.$q.defer()
    infoDetailFromDisk(invoice).then((data) => {
        const SIDParam = data.retcode ? data : $.parseJSON(data.value)
        // 已经开成功回写e税云
        if (SIDParam.retcode === '0' && (invoice.invType != 12 || SIDParam.ARRAY.length)) {
            SIDParam.xsdjbh = invoice.kplsh;
            SIDParam.waitId = invoice.waitId;
            const result = JSON.stringify(SIDParam)
            writeBackToInv(invoice.invType, result).then((res) => {
                deferred.resolve(SIDParam)
                invoice.invoiceId = res.data.value.invoiceId
            }, () => {
                deferred.reject({
                    retmsg: '发票已开具成功, 更新发票状态失败, 请稍后再试',
                })
            })
        } else if (invoice.description != '开票成功但入库失败，请重新点击开票进行修复') {
            deferred.resolve(openWhenUnlocked(invoice))
        } else {
            deferred.reject('发票已开具成功, 更新发票状态失败, 请稍后再试')
        }
    })
    return deferred.promise
}

export default class InvoiceOpenService {
    constructor(httpRequest, $q, $http) {
        this.httpRequest = httpRequest
        this.$q = $q
        this.$http = $http
    }

    /**
     * 根据ukeyId查询库存
     * @param  {array}  ukeyList 开票点列表
     * @param  {string} ukeyId   开票点id
     * @param  {string} invType     发票种类 传了返回对象，没传返回数组
     * @return {promise}         {sum: '库存数量'，invoiceNumber, invoiceCode}
     */
    getStockByUkey(ukeyList, ukeyId, invType = '') {
        const deferred = this.$q.defer()
        const service = this
        if (!ukeyList || !ukeyList.length) {
            deferred.reject('没有获取到开票点信息')
            return deferred.promise
        }
        const ukeyObj = ukeyList.filter((item) => item.ukeyId == ukeyId)[0]
        if (!ukeyObj) {
            deferred.reject('未选择开票点')
            return deferred.promise
        }
        // const resolveObj = {
        //     invoiceCode: '',
        //     invoiceNumber: '',
        //     sum: 0,
        //     invType,
        //     ukeyObj
        // }
        //服务器托管
        if (ukeyObj.manageType == 2) {
            this.httpRequest.post_qryStock({
                diskCode: ukeyObj.diskCode,
                ukeyCode: ukeyObj.ukeyCode,
                saleCreditCode: JSON.parse(localStorage.user_info).sale.saleCreditCode,
            }).then(res => {
                deferred.resolve(service.getInvoiceTotal(res.data.value, invType))
            })
            // if (invType == 12) {
            //     deferred.resolve(resolveObj)
            // } else {
            //     this.httpRequest.post_qryStock({
            //         diskCode: ukeyObj.diskCode,
            //         ukeyCode: ukeyObj.ukeyCode,
            //         saleCreditCode: JSON.parse(localStorage.user_info).sale.saleCreditCode,
            //         invType
            //     }).then(res => {
            //         deferred.resolve(service.getInvoiceTotal(res.data.value, invType))
            //     })
            // }
        }
        // 单机版
        else {
            stockService.getDiskInfo().then((res) => {
                if (!(JSON.parse(res).TaxCode)) {
                    deferred.reject('未启动或未插入金税盘')
                    return
                }
                if (JSON.parse(res).TaxCode !== JSON.parse(localStorage.user_info).sale.saleCreditCode) {
                    deferred.reject('金税盘税号与当前组织税号不一致')
                    return
                }
                if (JSON.parse(res).kpfwqh === ukeyObj.diskCode) {
                    stockService.queryInvoiceStock().then((res1) => {
                        service.httpRequest.post_storeSingerDiskStockInfo({
                            diskId: ukeyObj.diskId,
                            diskInvoiceStock: res1,
                        }).then(r => {
                            deferred.resolve(service.getInvoiceTotal(r.data.value, invType))
                        })
                        // const reg = {
                        //     invType: /<FPZL>(.*?)<\/FPZL>/g,
                        //     invoiceCount: /<FPFS>(.*?)<\/FPFS>/g,
                        //     invoiceCode: /<LBDM>(.*?)<\/LBDM>/g,
                        //     invoiceNumber: /<QSHM>(.*?)<\/QSHM>/g,
                        // }
                        // const resArr = utils.analysisXml(reg, res1).value
                        // deferred.resolve(service.getInvoiceTotal(resArr, invType, resolveObj))
                    })
                } else {
                    deferred.reject('未启动或未插入金税盘')
                }
            }, () => {
                deferred.reject('未启动或未插入金税盘')
            })
        }
        return deferred.promise
    }
    getInvoiceTotal(list, type) {
        if (type || type == '0') {
            const arr = list.filter(i => {
                return i.invType == type
            })
            return arr[0]
        }
        return list
    }
    /**
     * 封装checkWithDiskInfo, controller中不能调用金税盘
     * @param  {array} invoiceList 发票列表
     * @param  {string} invoiceList 校验方法
     * @return {promise}           盘信息
     */
    checkWithDiskInfo(invoiceList, method) {
        return checkWithDiskInfo(invoiceList, method)
    }

    checkAndscratch(invoice) {
        const deferred = this.$q.defer()
        const error = scratchCheck(invoice)
        if (error) {
            deferred.reject(error)
            return deferred.promise
        }
        return this.httpRequest.post_scratchOvatInvoiceWait(invoice)
    }

    scratch(invoice) {
        return this.httpRequest.post_scratchOvatInvoiceWait(invoice)
    }

    /**
     * 列表页面能单独提交不先调暂存
     */
    submit(invoice) {
        return this.httpRequest.post_submitOvatInvoiceWait(invoice.waitId)
    }

    /**
     * 编辑页面一定要先暂存再提交
     */
    scratchAndSubmit(invoice) {
        return this.scratch(invoice).then(() => (
            this.httpRequest.post_submitOvatInvoiceWait(invoice.waitId)
        ))
    }

    /**
     *
     * 重开生成待开
     */
    reopenInvoiceWait(invoice) {
        return this.httpRequest.post_reopenInvoiceWait(invoice).then(res => {
            invoice.waitId = res.data.value
        })
    }
    /**
     * 开电子票
     */
    openEletronic(invoice) {
        return this.httpRequest.post_immediateElectronOpenInv(invoice.waitId)
    }

    /**
     * 1. 检查盘和开票点
     * 2. 开票
     */
    checkDiskAndOpen(invoice) {
        const service = this
        const deferred = service.$q.defer()
        this.checkWithDiskInfo([invoice]).then(() => {
            deferred.resolve(service.open(invoice))
        }, (errorMsg) => {
            deferred.reject(errorMsg)
        })
        return deferred.promise
    }

    /**
     * 判断是否锁定
     * 分发锁定流程和未锁流程
     */
    open(invoice, deleteFlag = false) {
        const service = this
        const deferred = service.$q.defer()
        const openWhenLocked = openWhenLockedPrivate.bind(this)
        const openWhenUnlocked = openWhenUnlockedPrivate.bind(this)
        if (service.checkIsA9(invoice.ukeyId)) {
            service.httpRequest.post_openInvoice({
                waitId: invoice.waitId,
                deleteFlag
            }).then((res) => {
                if (res.data.value.code == 0) {
                    deferred.resolve()
                } else {
                    deferred.reject(res.data.value.msg)
                }
            }, () => {
                deferred.reject()
            })
        } else {
            if (invoice.isLock === '1') {
                deferred.resolve(openWhenLocked(invoice))
            } else {
                service.httpRequest.post_lockOvatInvoiceWait({
                    isLock: '1',
                    waitId: invoice.waitId,
                }).then((ret) => {
                    //add by wxb for [添加开票流水号字段] on 2019-11-21
                    invoice.kplsh = ret.data.value;
                    //END
                    deferred.resolve(openWhenUnlocked(invoice));
                })
            }
        }
        return deferred.promise
    }

    /**
     * 1. 打印
     * 2. 错误回写错误原因
     * @param  {object} invoice   发票对象
     * @param  {string} taxCode   税号
     * @param  {string} machineNo 机器号
     */
    print(invoice, taxCode, machineNo) {
        const service = this
        const deferred = this.$q.defer()
        if (this.checkIsA9(invoice.ukeyId)) {
            service.printHelperPrint(invoice).then(() => {
                deferred.resolve()
            }, (err) => {
                deferred.reject(err)
            })
        } else {
            window.top.TaxCore.tax.printInv(
                invoice.invType,
                invoice.invoiceCode,
                invoice.invoiceNumber,
                0,
                1,
                (data) => {
                    if (data.retcode === -1) {
                        deferred.reject(data)
                        return
                    }
                    const SIDParam1 = $.parseJSON(data.value)
                    if (SIDParam1.retcode === '5011') {
                        deferred.resolve(SIDParam1)
                        service.httpRequest.post_printBackToInvoice(invoice.invoiceId)
                    } else {
                        deferred.reject(SIDParam1)
                    }
                },
                taxCode,
                machineNo,
                0,
            )
        }
        return deferred.promise
    }


    // 打印助手
    printHelperPrint(invoice, isPrintListFlag) {
        const deferred = this.$q.defer()
        const service = this
        this.httpRequest.post_getOvatInvoiceForPrint({
            invoiceIds: invoice.invoiceId || invoice.waitId,
            invPrintFlag: isPrintListFlag ? '0' : '1'
        }).then(res => {
            let response = res.data.value
            const _path = `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host === 'localhost:3000' ? '127.0.0.1:8999' : 'soap.szhtxx.com:8999'}`
            let ws = new WebSocket(_path)
            ws.onopen = function () {
                ws.send(response);
            };
            ws.onerror = function (evt) {
                deferred.reject('请启动打印助手, 未打印成功！')
            };

            ws.onmessage = function (evt) {
                let data = JSON.parse(evt.data)
                if (data[0] && data[0].returnCode === "0000") {
                    service.httpRequest.post_printBackToInvoice(invoice.invoiceId || invoice.waitId)
                    deferred.resolve()
                } else {
                    deferred.reject(data.returnMessage)
                }
                ws.close();
            };
        })
        return deferred.promise
    }
    // 批量开票
    openBatch(invoiceList) {
        const service = this
        const deferred = service.$q.defer()
        let errorNum = 0

        function openBatchFun(currentIndex = 0) {
            const currentInvoice = invoiceList[currentIndex]
            deferred.notify(currentIndex)
            service.open(currentInvoice).then(() => {}, () => {
                ++errorNum
            }).finally(() => {
                if (currentIndex < invoiceList.length - 1) {
                    openBatchFun(++currentIndex)
                } else {
                    deferred.resolve(errorNum)
                }
            })
        }
        setTimeout(openBatchFun, 0)
        return deferred.promise
    }

    // 批量开票返回失败待开ID
    scanOpenBatch(invoiceList) {
        const service = this
        const deferred = service.$q.defer()
        const errorInvoiceIds = []

        function openBatchFun(currentIndex = 0) {
            const currentInvoice = invoiceList[currentIndex]
            deferred.notify(currentIndex)
            service.open(currentInvoice).then(() => {}, () => {
                errorInvoiceIds.push(currentInvoice.waitId)
            }).finally(() => {
                if (currentIndex < invoiceList.length - 1) {
                    openBatchFun(++currentIndex)
                } else {
                    deferred.resolve(errorInvoiceIds)
                }
            })
        }
        setTimeout(openBatchFun, 0)
        return deferred.promise
    }

    // 批量开票打印
    openPrintBatch(invoiceList, taxCode, machineNo) {
        const service = this
        const deferred = service.$q.defer()
        let errorNum = invoiceList.length

        function openPrintBatchFun(currentIndex = 0) {
            const currentInvoice = invoiceList[currentIndex]
            deferred.notify(currentIndex)
            service.open(currentInvoice).then(() => {
                service.print(currentInvoice, taxCode, machineNo).then(() => {
                    errorNum--
                    if (currentIndex < invoiceList.length - 1) {
                        openPrintBatchFun(++currentIndex)
                    } else {
                        deferred.resolve(errorNum)
                    }
                }, (error) => {
                    deferred.reject(error)
                }).finally(() => {})
            }, (error) => {
                deferred.reject(error)
            })
        }
        setTimeout(openPrintBatchFun, 0)
        return deferred.promise
    }

    // 批量开票打印 返回失败待开ID  仅适用于已开、红字信息表
    openPrintBatchBackID(invoiceList, taxCode, machineNo) {
        const service = this
        const deferred = service.$q.defer()
        let errorNum = invoiceList.length

        function openPrintBatchFun(currentIndex = 0) {
            const currentInvoice = invoiceList[currentIndex]
            deferred.notify(currentIndex)
            service.open(currentInvoice, true).then(() => {
                service.print(currentInvoice, taxCode, machineNo).then(() => {
                    errorNum--
                    if (currentIndex < invoiceList.length - 1) {
                        openPrintBatchFun(++currentIndex)
                    } else {
                        deferred.resolve(errorNum)
                    }
                }, (error) => {
                    error = typeof error === 'object' ? error : {
                        retmsg: error,
                    }
                    error.errorNum = errorNum
                    error.waitId = currentInvoice.waitId
                    deferred.reject(error)
                }).finally(() => {})
            }, (error) => {
                error = typeof error === 'object' ? error : {
                    retmsg: error,
                }
                error.errorNum = errorNum
                error.waitId = currentInvoice.waitId
                deferred.reject(error)
            })
        }
        setTimeout(openPrintBatchFun, 0)
        return deferred.promise
    }

    /**
     * 1. 检查盘和开票点
     * 2. 开票打印
     */
    checkDiskAndOpenPrint(invoice) {
        const service = this
        const deferred = service.$q.defer()
        if (this.checkIsA9(invoice.ukeyId)) {
            this.a9OpenPrint(invoice).then(() => {
                deferred.resolve()
            }, (err) => {
                deferred.reject(err)
            })
        } else {
            this.checkWithDiskInfo([invoice]).then((diskInfo) => {
                deferred.resolve(service.openPrint(invoice, diskInfo.taxCode, diskInfo.machineNo))
            }, (errorMsg) => {
                deferred.reject(errorMsg)
            })
        }
        return deferred.promise
    }

    /**
     * 开票打印
     */
    openPrint(invoice, taxCode, machineNo) {
        const service = this
        const deferred = service.$q.defer()
        service.open(invoice).then(() => {
            service.print(invoice, taxCode, machineNo).then((res) => {
                deferred.resolve(res)
            }, (err) => {
                deferred.reject(err)
            })
        }, (err) => {
            deferred.reject(err)
        })
        return deferred.promise
    }

    // 获取待开编号和创建时间
    getGetBeanIdDkfp() {
        return this.httpRequest.get_getBeanId_dkfp()
    }

    //  获取机动车开票税收分类默认版本号
    getQryVehicleTaxClass(accessToken) {
        return this.httpRequest.get_qryVehicleTaxClass(accessToken)
    }

    // 获取盘信息
    getTaxDiskInfo(ukeyId) {
        return this.httpRequest.get_getTaxDisk(ukeyId).then((res) => res.data)
    }

    // 银行列表
    postBankBySale() {
        return this.httpRequest.post_bankBySale()
    }

    // 获取发票
    queryInvoiceStock() {
        const reg = {
            code: /(<CODE>)(.*?)(<\/CODE>)/g,
            categoryCode: /<LBDM>(.*?)<\/LBDM>/g,
            invoiceType: /<FPZL>(.*?)<\/FPZL>/g,
            startNumber: /<QSHM>(.*?)<\/QSHM>/g,
            collectCount: /<FPFS>(.*?)<\/FPFS>/g,
            gmrq: /<GMRQ>(.*?)<\/GMRQ>/g,
            id: /<FPJH>(.*?)<\/FPJH>/g,
        }
        return new Promise((resolve, reject) => {
            stockService.queryInvoiceStock().then((res) => {
                resolve(utils.analysisXml(reg, res).value)
            }, err => {
                reject(err)
            })
        })
    }

    // 检测是否为本地托管
    checkIsAgent(invoice) {
        let isAgent = false
        const soap = localStorage.soap && JSON.parse(localStorage.soap)
        soap && soap.taxInfoList && soap.taxInfoList.diskList.forEach(item => {
            if (item.machineNO == invoice.diskCode && item.taxcode == invoice.saleCreditCode && item.manageType == 1 && localStorage.currentDiskCode !== item.machineNO) isAgent = true
        })
        return isAgent
    }

    //托管开票流程
    agentOpen(invoice, isRed) {
        const service = this
        const deferred = service.$q.defer()
        this.httpRequest.get_queryOvatInvoiceWaitByIssue({
            waitId: invoice.waitId,
            hardwareNo: invoice.hardwareNo,
        }, () => {
            deferred.reject()
        }).then(() => {
            this.httpRequest.post_agentOpenElecInvoice({
                isRed,
                waitId: invoice.waitId,
            }).then(() => {
                deferred.resolve()
            }, (err) => {
                service.httpRequest.post_writeOvatInvoiceFailReason({
                    reason: err,
                    waitId: invoice.waitId,
                })
                deferred.reject()
            })
        })
        return deferred.promise
    }

    //批量托管开票
    agentOpenBatch(invoiceList) {
        const service = this
        const deferred = service.$q.defer()
        const errorInvoiceIds = []

        function openBatchFun(currentIndex = 0) {
            const currentInvoice = invoiceList[currentIndex]
            deferred.notify(currentIndex)
            service.agentOpen(currentInvoice, currentInvoice.isRed).then(() => {}, () => {
                errorInvoiceIds.push(currentInvoice.waitId)
            }).finally(() => {
                if (currentIndex < invoiceList.length - 1) {
                    openBatchFun(++currentIndex)
                } else {
                    deferred.resolve(errorInvoiceIds)
                }
            })
        }
        setTimeout(openBatchFun, 0)
        return deferred.promise
    }

    //a9服务批量开票
    a9OpenBatch(invoiceList, isRed = '') {
        const service = this
        const deferred = service.$q.defer()
        const errorInvoiceIds = []

        function openBatchFun(currentIndex = 0) {
            const currentInvoice = invoiceList[currentIndex]
            deferred.notify(currentIndex)
            service.httpRequest.post_openInvoice({
                waitId: currentInvoice.waitId,
                deleteFlag: isRed
            }).then((res) => {
                if (res.data.value.code != 0) errorInvoiceIds.push(currentInvoice.waitId)
            }, () => {
                errorInvoiceIds.push(currentInvoice.waitId)
            }).finally(() => {
                if (currentIndex < invoiceList.length - 1) {
                    openBatchFun(++currentIndex)
                } else {
                    deferred.resolve(errorInvoiceIds)
                }
            })
        }
        setTimeout(openBatchFun, 0)
        return deferred.promise
    }
    //a9服务开票打印
    a9OpenPrint(invoice) {
        const service = this
        const deferred = service.$q.defer()
        service.httpRequest.post_openInvoice({
            waitId: invoice.waitId
        }).then((res) => {
            if (res.data.value.code == 0) {
                service.printHelperPrint(invoice).then(() => {
                    deferred.resolve()
                }, (err) => {
                    deferred.reject(err)
                })
            } else {
                deferred.reject(res.data.value.msg)
            }
        }, (err) => {
            deferred.reject(err)
        })
        return deferred.promise
    }
    //a9服务批量开票打印
    a9OpenPrintBatch(invoiceList) {
        const service = this
        const deferred = service.$q.defer()
        let errorNum = invoiceList.length

        function openPrintBatchFun(currentIndex = 0) {
            const currentInvoice = invoiceList[currentIndex]
            deferred.notify(currentIndex)
            service.httpRequest.post_openInvoice({
                waitId: currentInvoice.waitId
            }).then((res) => {
                if (res.data.value.code == 0) {
                    service.print(currentInvoice, taxCode, machineNo).then(() => {
                        errorNum--
                        if (currentIndex < invoiceList.length - 1) {
                            openPrintBatchFun(++currentIndex)
                        } else {
                            deferred.resolve(errorNum)
                        }
                    }, (error) => {
                        deferred.reject(error)
                    })
                } else {
                    deferred.reject(res.data.value.msg)
                }
            }, (error) => {
                deferred.reject(error)
            })
        }
        setTimeout(openPrintBatchFun, 0)
        return deferred.promise
    }

    //判断是否为a9服务器
    checkIsA9(ukeyId) {
        const ukeyList = JSON.parse(localStorage.user_info).sysUkeyList
        const ukey = ukeyList.filter(item => {
            return item.ukeyId == ukeyId
        })
        if(!ukeyList.length || !ukey.length) return false
        return (ukey[0].manageType == 2 || ukey[0].manageType == 3)
    }

    //批量操作校验 不允许单机、a9服务器混合
    chechManageTypeDiff(list) {
        let result = false
        let arr = []
        const ukeyList = JSON.parse(localStorage.user_info).sysUkeyList
        ukeyList.forEach(item => {
            list.forEach(u => {
                if (item.ukeyId == u.ukeyId) arr.push(item)
            })
        })
        const manageType = arr[0].manageType
        arr.forEach(i => {
            if (i.manageType != manageType) result = true
        })
        return result
    }
}
InvoiceOpenService.$inject = ['httpRequest', '$q', '$http']
invoiceModule.service('invoiceOpenService', InvoiceOpenService)



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/service/OpenService.js